<template>
  <div>
    <div class="fixed bottom-0 right-0 bg-blue-600 z-50 p-2 rounded-tl-lg">
      <svg
        style="height: 25px; width: 25px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 238.5249 220.4923"
      >
        <g>
          <path
            d="M143.782,57.453a80.5649,80.5649,0,0,1-23.58,57.0525,1.3775,1.3775,0,0,1-1.9415.0006A80.79,80.79,0,0,1,118.261.4a1.3775,1.3775,0,0,1,1.9415.0006A80.5646,80.5646,0,0,1,143.782,57.453Z"
            style="fill: #fff"
          />
          <path
            d="M237.966,132.4154a1.375,1.375,0,0,1,.126,1.8361,80.9558,80.9558,0,0,1-73.9457,30.2452,49.5052,49.5052,0,0,1,14.77,15.46,50.178,50.178,0,0,1,2.556,4.7973,1.3585,1.3585,0,0,1-.9985,1.9024,49.8039,49.8039,0,0,1-42.5472-13.02.6022.6022,0,0,0-.08-.08,48.9191,48.9191,0,0,1-5.15-5.74,37.6372,37.6372,0,0,1-7.07-19.13q-.12-1.5-.12-3.03a37.1621,37.1621,0,0,1,.24-4.25c.04-.39.1-.79.15-1.18.04-.28.08-.56.13-.84a77.41,77.41,0,0,1,1.79-8.48,80.3657,80.3657,0,0,1,20.91-36.22c.65-.65,1.31-1.28,1.97-1.9A80.5625,80.5625,0,0,1,207.54,71.0385a1.3756,1.3756,0,0,1,1.3426,1.3652,60.9944,60.9944,0,0,1-5.8556,26.163q-1.0958,2.34-2.41,4.62a61.5709,61.5709,0,0,1-21.17,21.76,49.7982,49.7982,0,0,1,58.5194,7.4688Z"
            style="fill: #fff"
          />
          <path
            d="M94.36,201.84c0-5.1509,2.7834-9.8139,7.28-13.192.345-.2382.6781-.4757,1.0112-.7139a61.9307,61.9307,0,0,0,16.1076-17.1953.556.556,0,0,1,.9487.0006,61.74,61.74,0,0,0,16.0966,17.1947c.3331.2382.6662.4757,1.0112.7139,4.4966,3.3781,7.28,8.0411,7.28,13.192,0,10.3018-11.1344,18.6525-24.862,18.6525C105.4944,220.4923,94.36,212.1416,94.36,201.84Z"
            style="fill: #fff"
          />
          <path
            d="M.4185,132.4154a1.3751,1.3751,0,0,0-.1259,1.8361,80.9558,80.9558,0,0,0,73.9457,30.2452,49.5067,49.5067,0,0,0-14.77,15.46,50.2231,50.2231,0,0,0-2.556,4.7973,1.3585,1.3585,0,0,0,.9986,1.9024,49.8044,49.8044,0,0,0,42.5472-13.02.5963.5963,0,0,1,.08-.08,48.9281,48.9281,0,0,0,5.15-5.74,37.64,37.64,0,0,0,7.07-19.13q.12-1.5.12-3.03a37.1621,37.1621,0,0,0-.24-4.25c-.04-.39-.1-.79-.15-1.18-.04-.28-.08-.56-.13-.84a77.4108,77.4108,0,0,0-1.79-8.48,80.3645,80.3645,0,0,0-20.91-36.22c-.65-.65-1.31-1.28-1.97-1.9A80.5626,80.5626,0,0,0,30.8449,71.0385a1.3756,1.3756,0,0,0-1.3426,1.3652,60.9944,60.9944,0,0,0,5.8556,26.163q1.0957,2.34,2.41,4.62a61.57,61.57,0,0,0,21.17,21.76A49.7987,49.7987,0,0,0,.4185,132.4154Z"
            style="fill: #fff"
          />
        </g>
      </svg>
    </div>

    <!-- Order details -->
    <div
      v-if="order"
      class="p-3"
    >
      <a
        @click.prevent="clearOrder()"
        class="border border-gray-400 text-sm text-blue-600 px-3 py-1 bg-gray-100 font-semibold rounded-full hover:bg-blue-600 hover:text-gray-100"
        href="#"
      >
        &lt;&lt;&nbsp;&nbsp;Back to Customer
      </a>

      <div class="pt-1">
        <order-details
          :order="order"
          :woo-commerce-url="wooCommerceUrl"
        />
      </div>
    </div>
    <!-- END Order details -->

    <!-- Customer details -->
    <div
      v-else-if="customer"
      class="p-3"
    >
      <a
        @click.prevent="clearCustomer()"
        class="border border-gray-400 text-sm text-blue-600 px-3 py-1 bg-gray-100 font-semibold rounded-full hover:bg-blue-600 hover:text-gray-100"
        href="#"
      >
        &lt;&lt;&nbsp;&nbsp;Search Customers
      </a>

      <div class="pt-1">
        <customer-details
          :customer="customer"
          @order="gotoOrder"
        />
      </div>
    </div>
    <!-- END Customer details -->

    <!-- Search and results -->
    <div v-else>
      <div class="input-group">
        <div class="flex rounded-none shadow-sm">
          <div class="relative flex items-stretch grow focus-within:z-10">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <UsersIcon
                class="h-5 w-5 text-blue-600"
                aria-hidden="true"
              />
            </div>
            <input
              v-model="query"
              type="text"
              class="focus:ring-blue-600 focus:border-l-blue-600 focus:border-r-blue-600 block w-full p-4 pl-10 text-base border-gray-400 rounded-none text-gray-800 font-semibold"
              placeholder="James Bong"
            />
          </div>
        </div>
      </div>

      <div v-if="query">
        <div class="flex-1 relative">
          <ul
            ref="results"
            class="grid grid-cols-1 divide-y"
          >
            <li
              v-if="searching"
              class="font-bold"
            >
              Searching...
            </li>
            <li
              v-if="!searching"
              v-for="item in customers"
              :key="`${item.id}`"
              class="flex justify-between items-center"
              tabindex="0"
            >
              <a
                class="cursor-pointer flex flex-col w-full px-3 py-2 hover:bg-gray-100"
                @click.prevent="gotoCustomer(item.id)"
              >
                <div class="font-semibold text-blue-600 capitalize">
                  <span>#{{ item.id }}: </span>
                  <span>{{ item.name.toLowerCase().trim() || item.email || '-' }}</span>
                </div>
                <small
                  v-if="item.email && item.name"
                  class="font-semibold text-sm text-gray-600 lowercase"
                >
                  {{ item.email }}
                </small>
              </a>
              <!-- <div>
                                <a @click.prevent="gotoCustomer(item.id)" class="border border-gray-400 text-sm text-blue-600 px-3 py-1 bg-gray-100 font-semibold rounded-full hover:bg-blue-600 hover:text-gray-100 ml-2" href="#">
                                    View
                                </a>
                            </div> -->
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- END Search and results -->
  </div>
</template>

<script>
import { UsersIcon } from '@heroicons/vue/solid'
import CustomerDetails from '@/Pages/External/Zendesk/Customers/Components/CustomerDetails'
import OrderDetails from '@/Pages/External/Zendesk/Customers/Components/OrderDetails'

export default {
  components: {
    UsersIcon,
    CustomerDetails,
    OrderDetails
  },

  props: {
    apiToken: {
      type: String,
      default: null
    },
    wooCommerceUrl: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      zaf: null,
      // searching
      query: null,
      searching: false,
      customers: [],
      // viewing
      customer: null,
      order: null
    }
  },

  computed: {
    origin() {
      if (!this.zaf) {
        return null
      }

      return this.zaf._origin
    }
  },

  watch: {
    query(newVal, oldVal) {
      if (newVal) {
        this.search()
      } else {
        this.clearSearch()
      }
    }
  },

  created() {
    this.zaf = ZAFClient.init()

    // this.zaf.get('ticket.requester.name').then(function(data) {
    //     console.log('ticket.requester.name', data);
    // });

    this.loading = false

    console.log('apiToken', this.apiToken)
    console.log('created()', 'v2', this.zaf, this.origin)
  },

  methods: {
    // Search
    search: _.debounce(
      function () {
        this.searching = true

        axios
          .post(
            route('external.zendesk.customers.search'),
            { query: this.query },
            {
              headers: {
                Authorization: `Bearer ${this.apiToken}`
              }
            }
          )
          .then((response) => {
            this.customers = response.data.data || []
            this.searching = false
          })
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),
    clearSearch() {
      this.query = null
      this.customers = []
      this.searching = false
    },
    // Customer details
    gotoCustomer(id) {
      // this.$inertia.visit(route('external.zendesk.customers.show', { customer: id }));
      axios
        .get(route('external.zendesk.customers.show', { customer: id }), {
          headers: {
            Authorization: `Bearer ${this.apiToken}`
          }
        })
        .then((response) => {
          this.customer = response.data
        })
    },
    clearCustomer() {
      this.customer = null
    },
    // Order details
    gotoOrder(item) {
      axios
        .get(route('external.zendesk.orders.show', { order: item.id }), {
          headers: {
            Authorization: `Bearer ${this.apiToken}`
          }
        })
        .then((response) => {
          this.order = response.data
        })
    },
    clearOrder() {
      this.order = null
    }
  }
}
</script>
